import { useEffect } from 'react';

import type { OfficeHost } from '../services/OfficeHostService';
import { ThemeService } from '../services/ThemeService';

const getHostVariables = (): Record<string, string> => ({
  '--accent': '#f54e00',
  '--accent-dark': '#d04200',
  '--accent-dim': 'rgba(245, 78, 0, 0.12)',
  '--accent-foreground': '#ffffff',
});

export function useHostVars(officeHost: OfficeHost) {
  useEffect(() => {
    ThemeService.applyTheme();

    const variables = getHostVariables();
    for (const [key, value] of Object.entries(variables)) {
      document.body.style.setProperty(key, value);
    }
  }, [officeHost]);

  return getHostVariables();
}
